import { FilterReportsInput, RoleType } from '@/graphql/generated/types';
import { useRoleGuard } from '@/auth/role/role.hooks';
import { Button } from '@/ui/button/button.component';
import { DebouncedInput } from '@/ui/debounced-input/debounced-input.component';
import { Link, RouteComponentProps } from '@reach/router';
import { pick } from 'lodash-es';
import React, { ComponentType } from 'react';
import { getPaginationFromQuery } from 'shared/helpers/pagination.helper';
import { usePaginatedUrlQuery } from 'shared/hooks/url-query';
import { Frame } from '../../frame';
import { ListView } from '../../ui/list-view/list-view.component';
import { Row } from '../../ui/table/row.component';
import { ReportDataFragment, useReportsQuery } from './list.generated';

type FilterType = {
  query?: string;
};

export const List: ComponentType<RouteComponentProps> = (props) => {
  const [query] = usePaginatedUrlQuery<FilterType>();
  const { hasRole, isSuper } = useRoleGuard();

  const { data, loading } = useReportsQuery({
    variables: {
      pagination: getPaginationFromQuery(query),
      filter: pick(query, ['query']),
    },
    fetchPolicy: 'network-only',
  });

  const isAdmin = isSuper || !!hasRole(RoleType.Admin);

  return (
    <>
      <Frame.Title>Berichte</Frame.Title>
      <Frame.SubTitle>Übersicht</Frame.SubTitle>

      {isAdmin && (
        <Frame.ActionBar>
          <Button linkTo="/reports/create" label="Neuer Bericht" />
        </Frame.ActionBar>
      )}

      <Frame.Content>
        <ListView<ReportDataFragment, FilterReportsInput>
          loading={loading}
          data={data?.adminReports?.data || []}
          totalCount={data?.adminReports?.totalCount}
          columns={[
            {
              name: 'Titel',
              sortable: true,
            },
            {
              name: 'Unternehmen',
              sortable: true,
            },
          ]}
          renderFilter={({ value, onChange }) => (
            <DebouncedInput
              debounceRate={400}
              value={value?.query || ''}
              onChange={(value) => onChange('query', value)}
              placeholder={'Suche …'}
            />
          )}
          renderRow={(item) => (
            <Row key={item.id}>
              <td>
                <Link to={`../${item.id}/edit`}>{item.title}</Link>
              </td>
              <td>{item.enterprise.name}</td>
            </Row>
          )}
        />
      </Frame.Content>
    </>
  );
};
